import React from 'react';

export default function WaitlistFields({ form, onChange }) {
  const capacity = Number(form.capacity);
  const enabled = form.waitlistMode === 'manual' || form.waitlistMode === 'automatic';
  if ((!Number.isFinite(capacity) || capacity < 1 || !['rsvp', 'ticketed'].includes(form.attendanceMode)) && !enabled) return null;
  return <div className="event-waitlist-settings">
    <label htmlFor="waitlistMode">When capacity is reached
      <select id="waitlistMode" name="waitlistMode" value={form.waitlistMode || 'off'} onChange={onChange} className="input">
        <option value="off">Close bookings</option>
        <option value="manual">Open waitlist · admin releases places</option>
        <option value="automatic">Open waitlist · release automatically</option>
      </select>
    </label>
    {enabled && <label htmlFor="waitlistClaimWindowHours">Time to claim an offered place (hours)
      <input id="waitlistClaimWindowHours" name="waitlistClaimWindowHours" type="number" min="1" max="168" step="1" value={form.waitlistClaimWindowHours || 24} onChange={onChange} className="input" required />
      <small className="text-muted">Offers close sooner if ticket sales, the RSVP deadline, or the event starts.</small>
    </label>}
  </div>;
}
